/*
 * @Description: 点击图片放大
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-05-07 10:22:09
 * @LastEditTime: 2021-07-19 13:35:04
 */
import Vue from 'vue';
import { VTooltip } from 'v-tooltip';

function imgListener(ev) {
  Vue.prototype
    .$alert(
      `<img style="width: auto;max-height:600px;margin-top:10px;" src=${ev.target.src} />`,
      ' ',
      {
        dangerouslyUseHTMLString: true,
        closeOnPressEscape: true,
        confirmButtonText: '关 闭',
        showConfirmButton: false,
        closeOnClickModal: true,
        showClose: true
      }
    )
    .catch(e => {
      console.log(e);
    });
}
function fapiaoPic(ev) {
  Vue.prototype
    .$alert(
      `<img style="width: auto;max-height:1030px;margin-top:10px;" src=${ev.target.src} />`,
      ' ',
      {
        dangerouslyUseHTMLString: true,
        closeOnPressEscape: true,
        confirmButtonText: '关 闭',
        showConfirmButton: false,
        closeOnClickModal: true,
        showClose: true
      }
    )
    .catch(e => {
      console.log(e);
    });
}
export const amplifyImg = {
  bind(el, binding) {
    console.log(binding);
    if (binding.value) {
      el.addEventListener('click', imgListener, false);
    }
  },
  unbind(el, binding) {
    if (binding.value) {
      el.removeEventListener('click', imgListener, false);
    }
  }
};

export const hovertip = VTooltip;
